import {
    Sun,
    Moon,
    Coffee,
    Zap,
    BookOpen,
    CheckCircle2,
    Briefcase,
    GlassWater,
    Pill,
    Brain
} from 'lucide-react';

/**
 * ADHD Friendly Daily Routine Templates
 * Designed to provide structure without overwhelm.
 */

export const ADHD_ROUTINES = {
    standard: {
        id: 'standard',
        name: 'Standard Balance',
        description: 'A balanced day with focus blocks and breaks.',
        icon: '⚖️',
        tasks: [
            // Morning
            { title: 'Hydrate & Meds', timeSlot: 'morning', duration: 10, icon: <Pill size={20} />, activeIcon: '💊' },
            { title: 'High Protein Breakfast', timeSlot: 'morning', duration: 20, icon: <Coffee size={20} />, activeIcon: '🍳' },
            { title: 'Morning Movement', timeSlot: 'morning', duration: 15, icon: <Sun size={20} />, activeIcon: '🧘' },

            // Day - Focus Blocks
            { title: 'Deep Work Block 1', timeSlot: 'day', duration: 45, icon: <Brain size={20} />, activeIcon: '🧠', tags: ['work'] },
            { title: 'Brain Break', timeSlot: 'day', duration: 15, icon: <Zap size={20} />, activeIcon: '⚡' },
            { title: 'Admin & Emails', timeSlot: 'day', duration: 30, icon: <Briefcase size={20} />, activeIcon: '📧', tags: ['admin'] },
            { title: 'Deep Work Block 2', timeSlot: 'day', duration: 45, icon: <Brain size={20} />, activeIcon: '🧠', tags: ['work'] },

            // Evening
            { title: 'Tidy Up (15 mins)', timeSlot: 'evening', duration: 15, icon: <CheckCircle2 size={20} />, activeIcon: '🧹', tags: ['household'] },
            { title: 'Plan Tomorrow', timeSlot: 'evening', duration: 10, icon: <BookOpen size={20} />, activeIcon: '📅' },
            { title: 'Wind Down', timeSlot: 'evening', duration: 30, icon: <Moon size={20} />, activeIcon: '😴' }
        ]
    },

    low_energy: {
        id: 'low_energy',
        name: 'Low Energy / Recovery',
        description: 'Gentle routine for tough days. Focus on essentials.',
        icon: '🔋',
        tasks: [
            { title: 'Drink Water', timeSlot: 'morning', duration: 5, icon: <GlassWater size={20} />, activeIcon: '💧' },
            { title: 'Take Meds', timeSlot: 'morning', duration: 5, icon: <Pill size={20} />, activeIcon: '💊' },
            { title: 'Easy Breakfast', timeSlot: 'morning', duration: 15, icon: <Coffee size={20} />, activeIcon: '🥣' },

            { title: 'One Major Task', timeSlot: 'day', duration: 30, icon: <CheckCircle2 size={20} />, activeIcon: '1️⃣', tags: ['work'] },
            { title: 'Rest & Recharge', timeSlot: 'day', duration: 30, icon: <Moon size={20} />, activeIcon: '🛋️' },

            { title: 'Order/Easy Dinner', timeSlot: 'evening', duration: 15, icon: <Coffee size={20} />, activeIcon: '🍕' },
            { title: 'Early Bedtime', timeSlot: 'evening', duration: 0, icon: <Moon size={20} />, activeIcon: '😴' }
        ]
    },

    hyperfocus: {
        id: 'hyperfocus',
        name: 'Hyperfocus Mode',
        description: ' maximized for deep work with mandatory hydration breaks.',
        icon: '🚀',
        tasks: [
            { title: 'Quick Fuel & Meds', timeSlot: 'morning', duration: 15, icon: <Pill size={20} />, activeIcon: '💊' },

            { title: 'FOCUS SPRINT 1', timeSlot: 'day', duration: 90, icon: <Zap size={20} />, activeIcon: '🔥', tags: ['work'] },
            { title: 'Mandatory Hydration', timeSlot: 'day', duration: 5, icon: <GlassWater size={20} />, activeIcon: '💧' },
            { title: 'FOCUS SPRINT 2', timeSlot: 'day', duration: 90, icon: <Zap size={20} />, activeIcon: '🔥', tags: ['work'] },
            { title: 'Food Fuel', timeSlot: 'day', duration: 30, icon: <Coffee size={20} />, activeIcon: '🍎' },
            { title: 'FOCUS SPRINT 3', timeSlot: 'day', duration: 60, icon: <Zap size={20} />, activeIcon: '🔥', tags: ['work'] },

            { title: 'Brain Dump', timeSlot: 'evening', duration: 15, icon: <BookOpen size={20} />, activeIcon: '📝' },
            { title: 'Disconnect Screens', timeSlot: 'evening', duration: 60, icon: <Moon size={20} />, activeIcon: '📵' }
        ]
    }
};

export const getRoutineTasks = (routineId) => {
    return ADHD_ROUTINES[routineId]?.tasks || ADHD_ROUTINES.standard.tasks;
};
